import { Icon } from "components";
import type { IconProps } from "components/Icon/Icon.d";
import type { ReactStoryblokComponent } from "types/storyblok";

const IconAdapter = ({ blok: { name, color, size }, sbEditable }: ReactStoryblokComponent<IconProps>) => (
  <Icon name={name} color={color} size={size} sbEditable={sbEditable} />
);

export default IconAdapter;
